(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 23986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(60175);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/Marketing/Main.js + 1 modules
var Main = __webpack_require__(5132);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./src/components/Marketing/PostList.js




function PostList(param) {
    var posts = param.posts;
    if (posts === "undefined") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            !posts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "No posts!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
                children: posts === null || posts === void 0 ? void 0 : posts.map(function(post) {
                    var _fields = post.fields, title = _fields.title, slug = _fields.slug;
                    console.log(post);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ListItem */.HC, {
                        mt: 10,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListIcon */.DE, {
                                as: dist_index_esm/* ChevronRightIcon */.XC
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/post/".concat(slug)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: title
                                })
                            })
                        ]
                    }, slug);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/blog.tsx




var Blog = function(param) {
    var posts = param.posts, title = param.title, description /*, ...props */  = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
        pageTitle: "".concat(title, " | Blog"),
        description: description,
        p: 20,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                children: "Welcome to my blog!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: "description",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList, {
                posts: posts
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var blog = (Blog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,5445,8641,8718,3382,1664,3001,3267,5132,9774,2888,179], function() { return __webpack_exec__(23986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);